import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SelectedRecipients } from "@/features/chat/components/SelectedRecipients";
import type { UserShort } from "@/lib/humhub-api/types";

interface SelectedRecipientsAccordionProps {
  recipients: UserShort[];
  onRemove: (user: UserShort) => void;
  label: string;
  countLabel: string;
  hasSelection: boolean;
}

export const SelectedRecipientsAccordion: React.FC<
  SelectedRecipientsAccordionProps
> = ({ recipients, onRemove, label, countLabel, hasSelection }) => {
  const [openSections, setOpenSections] = useState<string[]>([]);

  return (
    <Accordion value={openSections} onValueChange={setOpenSections}>
      <AccordionItem value="selected-recipients">
        <AccordionTrigger className="px-3 py-2 text-xs">
          {label}{" "}
          <span
            className={
              hasSelection ? "text-destructive" : "text-muted-foreground"
            }
          >
            ({countLabel})
          </span>
        </AccordionTrigger>
        <AccordionContent className="bg-transparent">
          <SelectedRecipients
            recipients={recipients}
            onRemove={onRemove}
            showTitle={false}
          />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
